import { render, staticRenderFns } from "./PointPayment.vue?vue&type=template&id=0caf0c10&scoped=true&"
import script from "./PointPayment.vue?vue&type=script&lang=js&"
export * from "./PointPayment.vue?vue&type=script&lang=js&"
import style0 from "./PointPayment.vue?vue&type=style&index=0&id=0caf0c10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf0c10",
  null
  
)

export default component.exports